
import socket from "../../lib/plugin/socket.js"

socket(window._hyperscript)

